<template>
  <v-row
    dense
    :no-gutters="dense"
  >
    <v-col
      v-for="(field, i) in fields"
      :key="getFieldKey(field, i)"
      :cols="getFieldCols(field)"
    >
      <FormFieldWrapper
        v-if="isFieldConfig(field)"
        ref="fieldRefs"
        :data="innerValue"
        :dense="dense"
        :errors="errors"
        :field="field"
        :rules="rules"
      />

      <FormFieldSet
        v-else-if="field.type === 'fieldset'"
        :dense="dense"
        :label="field.label"
      >
        <GenericFormLayout
          ref="fieldSetRefs"
          :dense="dense"
          :errors="errors"
          :fields="field.fields"
          :model-value="modelValue"
          :rules="rules"
          @update:model-value="emit('update:modelValue', $event)"
        />
      </FormFieldSet>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { FormFieldWrapper } from '#components';

const props = defineProps<{
  fields: FormConfig[]
  rules: FormRules
  errors: FormErrors
  modelValue: GenericFormData
  dense?: boolean
}>();
const emit = defineEmits(['update:modelValue']);

const innerValue = ref(props.modelValue || {});
watch(() => props.modelValue, () => innerValue.value = props.modelValue);
watch(innerValue, () => emit('update:modelValue', innerValue.value));
const getFieldKey = (field: FormConfig, i: number) => {
  if (isFieldConfig(field)) {
    return `field_${field.id}`;
  }
  else {
    return `${field.type}_${i}`;
  }
};
const getFieldCols = (field: FormConfig) => {
  const FULL_ROW = 12;
  return isFieldConfig(field)
    ? field.cols || FULL_ROW
    : FULL_ROW;
};

// Form reset logic
const fieldSetRefs = ref<any[]>([]);
const fieldRefs = ref<InstanceType<typeof FormFieldWrapper>[]>([]);
const reset = () => {
  fieldSetRefs.value.forEach(field => {
    field.reset();
  });
  fieldRefs.value.forEach(field => {
    field.reset();
  });
};

defineExpose({ reset });
</script>
